import { PureComponent, ReactNode } from 'react';
import AntSelect from './AntSelect';
import { AntSelectProps, OptionTypeBase } from './AntSelect';

interface Props<T extends OptionTypeBase, IsMulti extends boolean = false>
    extends AntSelectProps<T, IsMulti> {
    label?: string;
}

class AntSelectWithLabel<
    T extends OptionTypeBase,
    IsMulti extends boolean = false
> extends PureComponent<Props<T, IsMulti>> {
    render(): ReactNode {
        const { label, ...restProps } = this.props;

        return (
            <div className="dmultiselect">
                {label && (
                    <div>
                        <p className="font-700 text-12 text-neutral-3">{label}</p>
                    </div>
                )}
                <AntSelect className="w-full" {...restProps} />
            </div>
        );
    }
}

export default AntSelectWithLabel;
